
import React from 'react';
import { CostBreakdown } from '../types.ts';

interface CostBreakdownDisplayProps {
  breakdown: CostBreakdown;
}

const DetailRow: React.FC<{label: string, value: number, isSubtotal?: boolean, isTotal?: boolean, indent?: boolean}> = 
({label, value, isSubtotal=false, isTotal=false, indent=false}) => (
    <div className={`flex justify-between items-center py-2 px-3 ${isSubtotal ? 'bg-gray-100 rounded-md font-semibold' : ''} ${isTotal ? 'bg-sky-100 text-sky-800 rounded-md' : ''}`}>
        <span className={`${isTotal ? 'text-lg font-bold' : ''} ${indent ? 'pl-4' : ''}`}>{label}</span>
        <span className={`font-mono ${isTotal ? 'text-lg font-bold' : 'font-semibold'}`}>€ {value.toFixed(3)}</span>
    </div>
);


const CostBreakdownDisplay: React.FC<CostBreakdownDisplayProps> = ({ breakdown }) => {
  return (
    <div className="space-y-4">
        <div>
            <h4 className="font-bold text-lg text-gray-600 mb-1">1. Costo Filato</h4>
            <div className="border rounded-md p-2 space-y-1">
                <DetailRow label="Costo Cotone" value={breakdown.cottonMaterialCost} indent />
                <DetailRow label="Costo Filatura" value={breakdown.spinningCost} indent />
                {breakdown.elastomerCost > 0 && <DetailRow label="Costo Elastomero" value={breakdown.elastomerCost} indent />}
                <DetailRow label="Totale Filato" value={breakdown.totalYarnCost} isSubtotal />
            </div>
        </div>

        <div>
            <h4 className="font-bold text-lg text-gray-600 mb-1">2. Lavorazione Tessitura</h4>
             <div className="border rounded-md p-2 space-y-1">
                <DetailRow label="Costo Tessitura" value={breakdown.weavingCost} indent />
                <DetailRow label="Subtotale Greggio" value={breakdown.costAfterWeaving} isSubtotal />
                <DetailRow label="+ Calo Tessitura" value={breakdown.weavingWasteAmount} indent />
                <DetailRow label="Costo Post-Tessitura" value={breakdown.costAfterWeavingWaste} isSubtotal />
            </div>
        </div>

        <div>
            <h4 className="font-bold text-lg text-gray-600 mb-1">3. Lavorazione Finissaggio</h4>
             <div className="border rounded-md p-2 space-y-1">
                <DetailRow label="Costo Finissaggio" value={breakdown.finishingCost} indent />
                <DetailRow label="Subtotale" value={breakdown.costAfterFinishing} isSubtotal />
                 <DetailRow label="+ Calo Finissaggio" value={breakdown.finishingWasteAmount} indent />
                <DetailRow label="Costo T/Finito" value={breakdown.subtotal} isSubtotal />
            </div>
        </div>
        
         {breakdown.generalExpensesAmount > 0 && (
            <div>
                <h4 className="font-bold text-lg text-gray-600 mb-1">4. Spese Generali</h4>
                <div className="border rounded-md p-2 space-y-1">
                    <DetailRow label="Spese Generali" value={breakdown.generalExpensesAmount} indent />
                </div>
            </div>
         )}
        
        <DetailRow label="Costo Finale /m" value={breakdown.finalCost} isTotal />
    </div>
  );
};

export default CostBreakdownDisplay;
